//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import blok from '~/mixins/blok'
export default {
  mixins: [blok],
  computed: {
    personImage () {
      return this.$sb.parseImage(this.blok.person_image)
    },
    logo () {
      return this.$sb.parseImage(this.blok.logo)
    }
  }
}
